// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PlusIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M21 13.29h-7.71V21H10.7v-7.71H3V10.7h7.71V3h2.58v7.71H21z"
    />
  </svg>,
  "Plus",
);
export default PlusIcon;
